
import {PowerSearchDashboardConfig, Query} from "../../models/power-search.model";
import {
  GET_POWER_SEARCH_ANALYTIC_REPORT_FAIL_ACTION,
  GET_POWER_SEARCH_ANALYTIC_REPORT_SUCEESS_ACTION,
  GET_POWER_SEARCH_DASHBOARD_CONFIG_SUCCESS_ACTION,
  GetPowerSearchAnalyticReportFailAction,
  GetPowerSearchAnalyticReportSuccessAction,
  GetPowerSearchDashboardConfigSuccessAction,
  PowerSearchActions, SET_ENTITY_STATUS_ACTION,
  SET_QUERY_ACTION,
  SET_REPORT_PROJECT_ID, SetEntityStatusAction,
  SetQueryAction,
  SetReportProjectId
} from "../action/power-search-actions";

export interface IPowerSearchState {
  powerSearchDashboardConfig : PowerSearchDashboardConfig;
  query : Query;
  reportProjectId : string;
  reportDetails : any;
  error : any;
  hasEntities : boolean;
}

export const initialState: IPowerSearchState = {
  powerSearchDashboardConfig : null,
  query : null,
  reportProjectId : null,
  reportDetails : null,
  error : null,
  hasEntities : null
};



export function powerSearchReducer(state: IPowerSearchState = initialState, action: PowerSearchActions) {
  switch (action.type) {
    case GET_POWER_SEARCH_DASHBOARD_CONFIG_SUCCESS_ACTION:
      return <IPowerSearchState>{
        ...state,
        powerSearchDashboardConfig : (action as GetPowerSearchDashboardConfigSuccessAction).powerSearchDashboardConfig
      }
    case SET_QUERY_ACTION:
      return <IPowerSearchState>{
        ...state,
        query : (action as SetQueryAction).query
      }
    case SET_REPORT_PROJECT_ID:
      return <IPowerSearchState>{
        ...state,
        reportProjectId : (action as SetReportProjectId).projectId
      }
    case GET_POWER_SEARCH_ANALYTIC_REPORT_SUCEESS_ACTION:
      return <IPowerSearchState>{
        ...state,
        reportDetails : (action as GetPowerSearchAnalyticReportSuccessAction).reportDetails
      }
    case GET_POWER_SEARCH_ANALYTIC_REPORT_FAIL_ACTION:
      return <IPowerSearchState>{
        ...state,
        error : (action as GetPowerSearchAnalyticReportFailAction).error
      }
    case SET_ENTITY_STATUS_ACTION:
      return <IPowerSearchState>{
        ...state,
        hasEntities : (action as SetEntityStatusAction).hasEntities
      }
    default :
      return <IPowerSearchState>{
        ...state
      }
  }
}
